import React from 'react';
import PropTypes from 'prop-types';
import Sidebar from '../Sidebar';
import Bar from './bar';
import Content from './content';
import './styles.css';

class SidebarWrapper extends React.PureComponent {
  static propTypes = {
    children: PropTypes.array.isRequired,
  };

  render() {
    return (
      <Sidebar.Pushable>
        {this.props.children}
      </Sidebar.Pushable>
    );
  }
}

SidebarWrapper.Bar = Bar;
SidebarWrapper.Content = Content;

export default SidebarWrapper;
